import { ViewDefinition } from './types';

// Registry of analysis views. Order controls display order. Disabled views
// render as grayed-out "coming soon" options.
export const VIEWS: ViewDefinition[] = [
  {
    id: 'demand',
    label: 'Demand Trend',
    viewType: 'demand',
    recentRunsType: 'demand',
    enabled: true,
    params: ['business', 'region', 'fgids', 'siteIds', 'asins', 'dateRange'],
    chart: {
      dateColumn: 'local_date',
      dateMatch: (k) => /date|day/i.test(k),
      groupColumn: 'fgid',
      groupMatch: (k) => /fgid/i.test(k),
      metrics: [
        { title: 'Total demand', column: 'total_demand', match: (k) => /demand/i.test(k) },
        { title: 'Distinct ASINs', column: 'distinct_asins', match: (k) => /asin/i.test(k) },
      ],
    },
  },
  {
    id: 'lifespan',
    label: 'ASIN Lifespan',
    viewType: 'lifespan',
    recentRunsType: 'lifespan',
    enabled: true,
    params: ['business', 'region', 'fgids', 'siteIds', 'asins', 'dateRange'],
    chart: {
      dateColumn: 'snapshot_day',
      dateMatch: (k) => /date|day/i.test(k),
      groupColumn: 'site_id',
      groupMatch: (k) => /site/i.test(k),
      metrics: [
        {
          title: 'Active ASINs',
          column: 'active_asin_count',
          match: (k) => /asin/i.test(k),
        },
      ],
    },
  },
  {
    id: 'explainability',
    label: 'Explainability',
    viewType: 'explainability',
    enabled: true,
    params: [],
  },
  {
    id: 'forecast-divergence',
    label: 'Forecast Divergence',
    viewType: 'divergence',
    recentRunsType: 'divergence',
    enabled: true,
    params: ['business', 'region', 'fgids', 'asins', 'dateRange'],
    chart: {
      dateColumn: 'fcd',
      dateMatch: (k) => /fcd/i.test(k),
      groupColumn: 'target_date',
      groupMatch: (k) => /target_date/i.test(k),
      metrics: [
        { title: 'P50 Raw', column: 'p50_raw', match: (k) => /p50_raw/i.test(k) },
        { title: 'P90 Raw', column: 'p90_raw', match: (k) => /p90_raw/i.test(k) },
        { title: 'P50 Post-causal', column: 'p50_post_causal', match: (k) => /p50_post_causal/i.test(k) },
        { title: 'P90 Post-causal', column: 'p90_post_causal', match: (k) => /p90_post_causal/i.test(k) },
      ],
    },
  },
];

export const DEFAULT_VIEW_ID =
  VIEWS.find((v) => v.enabled)?.id ?? VIEWS[0].id;

export function getView(id: string): ViewDefinition {
  return VIEWS.find((v) => v.id === id) ?? VIEWS[0];
}
